import { render } from "./KpiScalarBox.vue?vue&type=template&id=403b4196"
import script from "./KpiScalarBox.vue?vue&type=script&lang=js"
export * from "./KpiScalarBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__